<template>
  <div id="app">
    <router-view />
    <Loading v-if="common.loading" />
    <Dialog v-if="common.dialog.open" />
    <Toast />
    <!-- 판매자센터 플로팅 배너: 모든 페이지에서 공통 노출 -->
    <SellerCenterFloatingBanner />
  </div>
</template>

<script>
import Loading from '@/components/common/Loading';
import Dialog from '@/components/common/Dialog';
import Toast from '@/components/common/Toast';
import SellerCenterFloatingBanner from '@/components/app/SellerCenterFloatingBanner';
import { useAuthStore } from "@/stores/auth";


export default {
  name: 'App',
  components: {
    Loading,
    Dialog,
    Toast,
    SellerCenterFloatingBanner
  },
  data() {
    return {
      authStore: useAuthStore(),
    };
  },
  async mounted() {
    this.authStore.restoreSession();
    await this.updateMetaTags();
  },
  watch: {
    // 페이지 이동 시에도 meta 갱신 (원하면 사용)
    '$route'() {
      this.updateMetaTags();
    }
  },
  methods: {
    updateMetaTags() {
      const host = window.location.hostname;

      // 문서 타이틀(메뉴명)은 router.beforeEach 에서만 관리하고,
      // 여기서는 og 메타 태그만 관리하도록 변경
      if (host.includes('omarket.kr')) {
        this.setMeta('og:title', ' 셀리오마켓');
        this.setMeta('og:description', ' 소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:url', 'https://omarker/kr');
      } else if (host.includes('kimmanager.co.kr')) {
        this.setMeta('og:title', '김매니저');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://kimmanager.co.kr');
      } else if (host.includes('shcolab.co.kr')) {
        this.setMeta('og:title', '시행착오랩');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://shcolab.co.kr');
      } else if (host.includes('withjikkoo.kr')) {
        this.setMeta('og:title', '위드직구');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://withjikkoo.co.kr');
      } else if (host.includes('kcode.store')) {
        this.setMeta('og:title', 'KCODE');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://kcode.store');
      } else if (host.includes('crosssell.co.kr')) {
        this.setMeta('og:title', '크로스셀');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://crossell.co.kr');
      } else if (host.includes('overlink.kr')) {
        this.setMeta('og:title', '오버링크');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://overlink.kr');
      } else if (host.includes('zijyasssssell.com')) {
        this.setMeta('og:title', '지쟈쓰');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://zijyasssssell.com');
      } else if (host.includes('osonupload.com')) {
        this.setMeta('og:title', '오손업로드');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://osonupload.com');
      } else if (host.includes('smartcross.kr')) {
        this.setMeta('og:title', '스마트크로스');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://smartcross.kr');
      } else {
        this.setMeta('og:title', '로컬호스트마켓');
        this.setMeta('og:description', '소싱부터 공급까지 한번에 다하는 성장형솔루션');
        this.setMeta('og:image', '');
        this.setMeta('og:url', 'https://localhost:8080');
      }
    },
    setMeta(property, content) {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (tag) {
        tag.setAttribute("content", content);
      } else {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        tag.setAttribute("content", content);
        document.head.appendChild(tag);
      }
    }
  }
};
</script>

<style lang="scss">
@import './assets/style/globalStyle.scss';
@import 'vue2-datepicker/index.css';
</style>